import { render, staticRenderFns } from "./UpdateInformationTab.vue?vue&type=template&id=532e22d4&scoped=true&"
import script from "./UpdateInformationTab.vue?vue&type=script&lang=ts&"
export * from "./UpdateInformationTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e22d4",
  null
  
)

export default component.exports